import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";

// The real ICC book catalog for the "Book Type" picker.
export default function useTspAddBookDistributionData() {
  return useTspApiResource(() => TspApiService.getBookCatalog(), []);
}
